import options from './sticky.directive';

export default {
    selector: 'dtSticky',
    options
};
